<template>
  <CardToolbox>
    <sdPageHeader title="Ongeldige aanvraag">

    </sdPageHeader>
  </CardToolbox>
  <Main>
    <a-row :gutter="30">

      <a-col :md="24" :xs="24">
        <sdCards headless>
         Deze link waarmee je deze pagina probeert te bezoeken is incorrect, deze is mogelijk verlopen. Neem contact op met uw contactpersoon om een geldige link te ontvangen.
        </sdCards>
      </a-col>
    </a-row>
  </Main>
</template>
<script>
import {defineComponent} from 'vue';
import {Main, CardToolbox} from '../styled';

const Sign = defineComponent({
  name: 'Sign',
  components: {Main, CardToolbox},
  data() {
    return {
      showEditDrawer: false,
    }
  },
});

export default Sign;
</script>

<style>

.signature canvas {
  width: 450px;
  height: 200px;
}

</style>
